import React, { useState, useEffect } from "react";
import Services from "../../components/Services";
import contentService from "../../services/contentService";

export default function ServicesPage() {
  const [servicesContent, setServicesContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServicesContent = async () => {
      try {
        const response = await contentService.getServicesContent();
        if (response.success) {
          setServicesContent(response.data);
        } else {
          setError("Failed to load content");
        }
      } catch (err) {
        setError("Failed to load content");
        console.error("Error fetching services content:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchServicesContent();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger text-center" role="alert">
        {error}
      </div>
    );
  }

  return <Services content={servicesContent} />;
}
